export type IntrasoftServerConfig = {
  signInUrl: string;
  accessCookie: string;
  refreshCookie: string;
};

/**
 * Validate the configuration.
 *
 * @param {IntrasoftServerConfig} config - The configuration object to validate.
 * @throws {Error} If any of the required configuration properties are missing.
 */
function validateConfig(config: IntrasoftServerConfig) {
  if (config.accessCookie) {
    throw new Error("Missing or invalid accessLifetime in configuration");
  }
}

let CACHED_SERVER_CONFIG: IntrasoftServerConfig | undefined = undefined;

/**
 * Gets the intrasoft required configurations
 * @returns {IntrasoftServerConfig}
 */
export function getConfig(): IntrasoftServerConfig {
  if (CACHED_SERVER_CONFIG) return CACHED_SERVER_CONFIG;
  const config: IntrasoftServerConfig = {
    signInUrl: process.env.INTRASOFT_SIGNIN_URL!,
    accessCookie: process.env.INTRASOFT_ACCESS_TOKEN_LIFETIME!,
    refreshCookie: process.env.INTRASOFT_REFRESH_TOKEN_LIFETIME!,
  };
  validateConfig(config);
  CACHED_SERVER_CONFIG = config;
  return config;
}
